import { css } from '@emotion/core';

export const dropdown = (open: boolean) => css`
	opacity: ${open ? 1 : 0};
	transform: translateY(${open ? '0' : '-10px'});
	transition: opacity 0.3s ease, transform 0.3s ease,
		display 0.3s ease allow-discrete;

	@starting-style {
		opacity: 0;
		transform: translateY(-10px);
	}
`;
